const ink = "#0E3A2A";
const inkMuted = "#6B7770";
const hairline = "#E5DCC8";
const hairlineStrong = "#D8CCB2";
const yellow = "#F2E94E";
const mintStrong = "#9FD9B6";
const mintInk = "#0A2A1E";
const displayFont = `"Fraunces", Georgia, serif`;

type ReviewState = "available" | "submitted" | "reviewed";

const styles = {
  card: (state: ReviewState) => ({
    p: "22px 22px 20px",
    mb: 1,
    borderRadius: "20px",
    border: "1px solid",
    borderColor:
      state === "submitted"
        ? "#ECDF5C"
        : state === "reviewed"
          ? mintStrong
          : hairline,
    background:
      state === "submitted"
        ? "linear-gradient(180deg, #FEFCE8 0%, #FFFFFF 55%)"
        : state === "reviewed"
          ? "linear-gradient(180deg, #F3FBF6 0%, #FFFFFF 55%)"
          : "#FFFFFF",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
  }),
  badge: (state: ReviewState) => ({
    display: "inline-flex",
    alignItems: "center",
    alignSelf: "flex-start",
    gap: "7px",
    py: "6px",
    pl: "12px",
    pr: "14px",
    mb: "18px",
    borderRadius: "999px",
    fontSize: 13,
    fontWeight: 700,
    backgroundColor:
      state === "submitted" ? yellow : state === "reviewed" ? mintStrong : ink,
    color:
      state === "available" ? "#fff" : state === "reviewed" ? mintInk : ink,
    "& svg": {
      color: state === "available" ? mintStrong : "inherit",
    },
  }),
  title: {
    fontFamily: displayFont,
    fontWeight: 600,
    fontSize: 25,
    lineHeight: 1.1,
    letterSpacing: "-0.5px",
    color: ink,
    m: "0 0 10px",
  },
  body: {
    fontSize: 14,
    lineHeight: 1.5,
    color: inkMuted,
    m: "0 0 20px",
    "& strong": { color: ink, fontWeight: 600 },
  },
  cta: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    width: "100%",
    mt: "auto",
    py: "14px",
    px: "18px",
    borderRadius: "14px",
    backgroundColor: ink,
    color: "#fff",
    fontSize: 14,
    fontWeight: 600,
    letterSpacing: "0.3px",
    textTransform: "none",
    "&:hover": { backgroundColor: "#07271c" },
    "&.Mui-disabled": { backgroundColor: ink, opacity: 0.6, color: "#fff" },
  },
  status: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    mt: "auto",
    pt: "6px",
    fontSize: 13,
    color: inkMuted,
  },
  dismiss: {
    alignSelf: "flex-start",
    mt: "4px",
    p: 0,
    minWidth: 0,
    fontSize: 13,
    fontWeight: 600,
    color: inkMuted,
    textTransform: "none",
    "&:hover": { backgroundColor: "transparent", color: ink },
  },
  spinner: {
    width: 16,
    height: 16,
    borderRadius: "50%",
    border: `2px solid ${hairlineStrong}`,
    borderTopColor: "#C5A82A",
    flexShrink: 0,
    animation: "reviewSpin 0.9s linear infinite",
    "@keyframes reviewSpin": {
      to: { transform: "rotate(360deg)" },
    },
  },
} as const;

export default styles;
